/**
 * @generated SignedSource<<54bc55836a9dce137cbee64d3e9330f5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileVerificationButton_profile$data = {
  readonly isVerified: boolean | null | undefined;
  readonly name: string;
  readonly userId: any;
  readonly verificationRequested: boolean | null | undefined;
  readonly " $fragmentType": "ProfileVerificationButton_profile";
};
export type ProfileVerificationButton_profile$key = {
  readonly " $data"?: ProfileVerificationButton_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileVerificationButton_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileVerificationButton_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationRequested",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "6d248bd0fddb83a43479d86372a9c9aa";

export default node;
